import { createAsyncThunk } from '@reduxjs/toolkit'
import { login } from '@/api/login'


export const loginAsync = createAsyncThunk(
  'user/loginAsync',
  async (data, thunkAPI) => {
    const res = await login(data)
    return res
  }
)
